import { Icon, type IconProps } from './Icon';

export function BrowserIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="2" y="3" width="20" height="18" rx="2" />
      <path d="M2 8h20" />
      <path d="M6 5.5h.01M9 5.5h.01" />
      <path d="M6 12h6M6 16h4" />
    </Icon>
  );
}
